import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmptyComponent } from './empty/empty.component';
import { HomeComponent } from './home/home.component';
import { AdminLoginComponent } from './admin/pages/admin-login/admin-login.component';
import { AdminLeadRequestsComponent } from './admin/pages/admin-lead-requests/admin-lead-requests.component';
import { AdminAuthGuard } from './admin/auth/admin-auth.guard';

const routes: Routes = [
  {
    path: 'admin',
    children: [
      { path: 'login', component: AdminLoginComponent },
      { path: 'solicitudes', component: AdminLeadRequestsComponent, canActivate: [AdminAuthGuard] },
      { path: '', pathMatch: 'full', redirectTo: 'solicitudes' }
    ]
  },
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'inicio',
        component: EmptyComponent
      },
      {
        path: 'sobre-mi',
        component: EmptyComponent
      },
      {
        path: 'experiencia',
        component: EmptyComponent
      },
      {
        path: 'areas',
        component: EmptyComponent
      },
      {
        path: 'contacto',
        component: EmptyComponent
      }
    ]
  },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
